<template>
    <div>
        <el-page-header class="page-header" @back="goBack" content="采购详情">
        </el-page-header>
        <!-- 订单状态信息 -->
        <div class="order-status">
            <div class="status-text">
                <span class="order-sn">采购单号：{{ detailData.order_sn }}</span>
            </div>
            <div class="payment-info">
                <div>
                    <div style="display: flex; align-items: center;">
                        <div class="payment-status">{{ detailData.status_name }}</div>
                        <div v-if="detailData.status <= '4' && detailData.status >= '0'">
                            <el-statistic class="daojishi" format="DD天HH小时mm分钟"
                                :value="new Date(detailData.query_end_date)" time-indices>
                                <template slot="suffix">
                                    后结束
                                </template>
                            </el-statistic>
                        </div>
                    </div>
                    <div class="payment-tip" v-if="detailData.status == '1'">等待买家选择商家进入询价阶段</div>
                    <div class="payment-tip" v-if="detailData.status == '5'">已配载完成，等待发货</div>
                    <div class="payment-tip" v-if="detailData.status == '8'">买家已确认收货，待买家付款结算</div>
                </div>
                <div>
                    <template v-if="detailData.status == '1' || detailData.status == '2' || detailData.status == '3'">
                        <el-button type="primary" size="small" @click="exitQuotation">退出报价</el-button>
                    </template>
                    <template v-if="detailData.status == '4'">
                        <el-button type="primary" size="small" @click="cancelCooperation">取消合作</el-button>
                        <el-button type="primary" size="small" @click="delayLoadingVisible = true">申请延时配载</el-button>
                    </template>
                    <span v-if="detailData.status == '5'" class="tips">
                        请前往搏忆购APP内发货
                    </span>
                </div>
            </div>
        </div>
        <div class="userBox">
            <div class="buyer-info">
                <img class="buyer-avatar" :src="detailData.user_info.avatar">
                <div class="buyer-name">{{ detailData.user_info.nickname }}</div>
            </div>
            <el-button type="primary" size="small" @click="goChat(detailData.user_id)">聊生意</el-button>
        </div>
        <div class="info-section">
            <div class="info-box">
                <div class="section-title">采购信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">采购标题：</span>
                        <span class="info-value">{{ detailData.title }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">采购要求：</span>
                        <span class="info-value">{{ detailData.needs }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">结算周期：</span>
                        <span class="info-value">{{ detailData.settle_type_name }}</span>
                    </div>
                </div>
            </div>
            <div class="info-left" v-if="detailData.status >= 4">
                <div class="section-title">收货人信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">收货人：</span>
                        <span class="info-value">{{ detailData.address_info.real_name }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">联系电话：</span>
                        <span class="info-value">{{ detailData.address_info.mobile }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">收货地址：</span>
                        <span class="info-value">{{ detailData.address_info.detail }}</span>
                    </div>
                </div>
            </div>
            <div class="info-right">
                <div class="section-title">开票信息</div>
                <div class="info-content">
                    <div class="info-item">
                        <span class="info-label">开票人：</span>
                        <span class="info-value">{{ detailData.invoice_info.username }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">开票类型：</span>
                        <span class="info-value">{{ detailData.invoice_info.type_name }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">联系邮箱：</span>
                        <span class="info-value">{{ detailData.invoice_info.email }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">联系电话：</span>
                        <span class="info-value">{{ detailData.invoice_info.mobile }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-box">
            <div class="line"></div>
            <div class="page-title">采购商品</div>
        </div>
        <!-- 商品列表 -->
        <el-table :data="detailData.goods_list" style="width: 100%" :border="true">
            <el-table-column prop="name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="num" label="采购数量" align="center" />
            <el-table-column label="可接受采购量误差" align="center">
                <template slot-scope="scope">
                    <span>±{{ scope.row.error_range }}{{ scope.row.unit }}</span>
                </template>
            </el-table-column>
            <el-table-column label="平台参考价" align="center">
                <template slot-scope="scope">
                    <span>±{{ scope.row.refer_price }}/{{ scope.row.unit }}</span>
                </template>
            </el-table-column>
        </el-table>
        <template>
            <div class="page-box" style="margin-top: 20px;">
                <div class="line"></div>
                <div class="page-title">配载信息</div>
            </div>
            <!-- 提交配载信息 -->
            <el-table :data="stowage_arr" style="width: 100%" :border="true" v-if="detailData.status == '4'">
                <el-table-column prop="name" label="商品名称" align="center">
                </el-table-column>
                <el-table-column prop="required_quantity" label="采购数量" align="center" />
                <el-table-column label="我的报价单价" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.price }}/{{ scope.row.unit }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="实际配载量" align="center">
                    <template slot-scope="scope">
                        <div class="flex align-center">
                            <el-input v-model="scope.row.real_num" placeholder="请输入实际配载量" style="margin: 0 5px;"
                                @input="calculateTotalPrice(scope.row)" /><span>{{ scope.row.unit }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="real_price" label="总金额" align="center" />
                <el-table-column label="质检报告" align="center">
                    <template slot-scope="scope">
                        <ImageUpload :image-url="scope.row.quality_picture"
                            @upload-success="handleImgUpload(scope.row, $event)" :max-files="1" />
                    </template>
                </el-table-column>
            </el-table>
            <div class="feeBox" v-if="detailData.status == '4'">
                <el-button size="small" type="primary" @click="submitStowage">配载完成</el-button>
            </div>
            <!-- 已提交完配载信息 -->
            <el-table :data="detailData.peizai_list" style="width: 100%" :border="true" v-if="detailData.status > '4'">
                <el-table-column prop="name" label="商品名称" align="center">
                </el-table-column>
                <el-table-column prop="required_quantity" label="采购数量" align="center">
                </el-table-column>
                <el-table-column label="我的报价单价" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.price }}/{{ scope.row.unit }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="real_num" label="实际配载量" align="center">
                </el-table-column>
                <el-table-column prop="real_money" label="总金额" align="center">
                </el-table-column>
                <el-table-column label="质检报告" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.quality_picture" alt="质检报告" style="width: 50px; height: 50px;">
                    </template>
                </el-table-column>
                <el-table-column label="产品证书" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.product_certificate" alt="产品证书" style="width: 50px; height: 50px;">
                    </template>
                </el-table-column>
            </el-table>
            <div class="shipping_fee">运费：{{ detailData.my_quotation.shipping_fee }}元 </div>
        </template>
        <template v-if="detailData.status == '1' || detailData.status == '2' || detailData.status == '3'">
            <div class="page-box" style="margin-top: 20px;">
                <div class="line"></div>
                <div class="page-title">我的报价</div>
            </div>
            <el-table :data="detailData.my_goods" style="width: 100%" :border="true">
                <el-table-column prop="name" label="商品名称" align="center">
                </el-table-column>
                <el-table-column label="可接受采购量误差" align="center">
                    <template slot-scope="scope">
                        <span>±{{ scope.row.error_range }}{{ scope.row.unit }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="平台参考价" align="center">
                    <template slot-scope="scope">
                        <span>±{{ scope.row.refer_price }}/{{ scope.row.unit }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="报价折扣率" align="center">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.ratio" placeholder="请选择折扣率" @change="updatePrice(scope.row)">
                            <el-option v-for="(item, index) in discountList" :key="index" :label="item.value"
                                :value="item.value" />
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="我的报价单价" align="center">
                    <template slot-scope="scope">
                        <div class="flex align-center">
                            <span>¥</span><el-input v-model="scope.row.quotation_price" placeholder="请输入报价单价"
                                style="margin: 0 5px;" @input="updateDiscount(scope.row)" />/<span> {{ scope.row.unit
                                }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="feeBox">
                <span>运费价格：</span>
                <el-input v-model="new_shipping_fee" type="number" placeholder="请输入运费" min="1" />
            </div>
            <div class="feeBox">
                <el-button size="small" type="primary" @click="againPrice">重新报价</el-button>
            </div>
        </template>

        <template v-if="detailData.status == '1'">
            <div class="page-box" style="margin-top: 20px;">
                <div class="line"></div>
                <div class="page-title">商家报价排名</div>
            </div>
            <el-table :data="detailData.rank" style="width: 100%" :border="true">
                <el-table-column type="index" label="排名" align="center" width="100">
                </el-table-column>
                <el-table-column prop="store_name" label="商家" align="center" />
                <el-table-column prop="total_amount" label="综合报价" align="center" />
            </el-table>
        </template>
        <div class="info-section" style="margin-top: 20px;">
            <template v-if="detailData.status >= '6' && detailData.logistics">
                <div class="info-box">
                    <div class="section-title">物流信息</div>
                    <div class="info-content flex align-center flex-wrap" style="margin-bottom: 20px;">
                        <img :src="detailData.logistics.license_plate_number_image" alt=""
                            style="width: 120px; height: 120px; margin-right: 20px;">
                        <div class="flex-sub flex flex-direction-column justify-around" style="height: 120px;">
                            <div>
                                <span>{{ detailData.logistics.drivers_name }}</span>
                                <span style="margin-left: 20px;">{{ detailData.logistics.drivers_age }}岁</span>
                            </div>
                            <div>
                                <span>{{ detailData.logistics.license_plate_number }}</span>
                                <span style="margin-left: 20px;">{{ detailData.logistics.contact_number }}</span>
                            </div>
                            <div>{{ detailData.logistics.drivers_license_number }}</div>
                        </div>
                    </div>
                </div>
                <div class="info-left">
                    <div class="section-title">发货方签字</div>
                    <div class="info-content" style="display: flex; align-items: center; flex-wrap: wrap;">
                        <div style="width: 50%;">
                            <el-image :src="detailData.logistics.merchant_sign" alt="" class="sign-img"
                                :preview-src-list="[detailData.logistics.merchant_sign]" />
                            <div class="sign-text">商家签字</div>
                        </div>
                        <div style="width: 50%;">
                            <el-image :src="detailData.logistics.logistics_sign" alt="" class="sign-img"
                                :preview-src-list="[detailData.logistics.logistics_sign]" />
                            <div class="sign-text">物流签字</div>
                        </div>
                    </div>
                </div>
                <div class="info-right">
                    <div class="section-title">装车照片</div>
                    <div class="info-content" style="display: flex; align-items: center; flex-wrap: wrap;">
                        <el-image :src='item' v-for="(item, index) in detailData.logistics.upload_picture" :key="index"
                            class="load-img" :preview-src-list="detailData.logistics.upload_picture" />
                    </div>
                </div>
            </template>
            <template v-if="detailData.status >= '8'">
               <div class="info-left">
                    <div class="section-title">收货方签字</div>
                    <div class="info-content" style="display: flex; align-items: center; flex-wrap: wrap;">
                        <div style="width: 50%;">
                            <el-image :src="detailData.logistics.logistics_buy_sign" alt="" class="sign-img"
                                :preview-src-list="[detailData.logistics.logistics_buy_sign]" />
                            <div class="sign-text">买家签字</div>
                        </div>
                        <div style="width: 50%;">
                            <el-image :src="detailData.logistics.purchase_sign" alt="" class="sign-img"
                                :preview-src-list="[detailData.logistics.purchase_sign]" />
                            <div class="sign-text">物流签字</div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <!-- 物流信息 -->
        <!-- <el-dialog title="物流信息" :visible.sync="logisticsVisible" width="60%" center>
            <ViewLogistics v-if="detailData.aid" :orderId="detailData.aid" :isAfter="false" />
        </el-dialog> -->
        <el-dialog title="配载延时" :visible.sync="delayLoadingVisible" width="30%" center>
            <el-form label-position="top" label-width="80px" :model="delayLoadingForm">
                <el-form-item label="延时配载时间">
                    <div style="display: flex;">
                        <el-input type="number" v-model="delayLoadingForm.delay_time" style="flex: 1;"
                            placeholder="请输入延时配载时间" min="1"></el-input><span>小时</span>
                    </div>
                </el-form-item>
                <el-form-item label="延时原因">
                    <el-input type="textarea" v-model="delayLoadingForm.delay_reason" placeholder="请输入延时原因"></el-input>
                </el-form-item>
                <div style="display: flex; align-items: center; justify-content: center;">
                    <el-button type="primary" @click="cancelDelay">取消</el-button>
                    <el-button type="primary" @click="applyDelayLoading">提交</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload.vue'
import ViewLogistics from '@/components/ViewLogistics.vue'
import { ensureGoEasyConnected } from '@/utils/goeasy'
export default {
    name: 'purchaseOrderDetail',
    components: {
        ViewLogistics,
        ImageUpload,
    },
    props: {
        aid: {
            type: [String, Number],
            default: ''
        },
    },
    data() {
        return {
            detailData: {
                my_quotation: {
                    goods_list: [],
                },
                user_info: {
                    avatar: '',
                    nickname: '',
                },
                my_goods: [],
                goods_list: [],
                logistics: {
                    upload_picture: [],
                },
                address_info: {},
                invoice_info: {},
            }, // 订单详情
            discountList: [], // 折扣率列表
            new_shipping_fee: '', // 新的运费价格
            stowage_arr: [], // 配载商品列表
            delayLoadingVisible: false, // 延迟配载弹窗是否可见
            delayLoadingForm: {
                delay_time: '', // 延时配载时间
                delay_reason: '', // 延时原因
            },
            logisticsVisible: false, // 物流弹窗是否可见
        }
    },
    mounted() {
        this.getOrderDetail();
        this.getDiscountList();
    },
    methods: {
        goChat(){
            // 判断是否已登录
            if (!this.$store.getters.isLoggedIn) {
                this.$message.warning('请先登录');
                this.$router.push('/login');
                return;
            }
            // 已登录：确保 GoEasy 连接（断线则重连）
            ensureGoEasyConnected(this.$store.getters.getUserInfo).then((connected) => {
                if (!connected) {
                    this.$message.error('聊天服务连接失败，请稍后重试');
                    return;
                }
                this.$router.push('/message');
            });
        },
        // 计算商品总金额
        calculateTotalPrice(item) {
            item.real_price = (Number(item.real_num) * Number(item.price)).toFixed(2);
        },
        // 处理图片上传
        handleImgUpload(item, imageUrl) {
            item.quality_picture = imageUrl[0];
        },
        // 返回订单列表
        goBack() {
            this.$emit('goToComponent', 'purchaseOrderList');
        },
        submitStowage() {
            let is_empty = this.stowage_arr.some(item => item.real_price == '' || item.real_price <= 0);
            if (is_empty) return this.$message.info('请填写完整');
            let is_empty1 = this.stowage_arr.some(item => item.quality_picture == '');
            if (is_empty1) return this.$message.info('请上传质检报告');
            let arr = this.stowage_arr.map(item => {
                return {
                    aid: item.quotation_aid,
                    real_price: item.real_price,
                    quality_picture: item.quality_picture,
                    real_num: item.real_num,
                }
            })
            this.$api.submitStowage({
                aid: this.aid,
                goods_info: JSON.stringify(arr),
            }).then(res => {
                this.$message.success('配载成功');
                this.getOrderDetail();
            }).catch(err => {
                this.$message.error(err);
            })
        },
        // 申请延迟配载
        applyDelayLoading() {
            if (!this.delayLoadingForm.delay_time) return this.$message.info('请输入延时配载时间');
            if (!this.delayLoadingForm.delay_reason) return this.$message.info('请输入延时原因');
            this.$api.applyDelayLoading({
                aid: this.aid,
                hour: this.delayLoadingForm.delay_time,
                reason: this.delayLoadingForm.delay_reason,
            }).then(res => {
                this.$message.success('延时配载成功');
                this.getOrderDetail();
                this.cancelDelay();
            }).catch(err => {
                this.$message.error(err);
            })
        },
        // 取消延时配载
        cancelDelay() {
            this.delayLoadingVisible = false;
            this.delayLoadingForm.delay_reason = '';
            this.delayLoadingForm.delay_time = '';
        },
        // 取消合作
        cancelCooperation() {
            this.$confirm('确定取消合作吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.$api.exitQuotation({
                    aid: this.aid
                }).then(res => {
                    this.$message.success('取消合作成功');
                    setTimeout(() => {
                        this.goBack();
                    }, 1000);
                }).catch(err => {
                    this.$message.error(err);
                })
            })
        },
        // 退出报价
        exitQuotation() {
            this.$confirm('确定退出报价吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.$api.exitQuotation({
                    aid: this.aid
                }).then(res => {
                    this.$message.success('退出报价成功');
                    setTimeout(() => {
                        this.goBack();
                    }, 1000);
                }).catch(err => {
                    this.$message.error(err);
                })
            })
        },
        // 重新报价
        againPrice() {
            let goods_arr = this.detailData.my_goods;
            let arr1 = goods_arr.filter(item => item.price != '');
            if (arr1.length == 0) return this.$message.info('请填写金额');
            if (!this.new_shipping_fee) return this.$message.info('请输入运费');
            let arr = goods_arr.map(item => {
                return {
                    goods_id: item.aid,
                    price: item.quotation_price,
                    goods_category_id: item.goods_category_id
                }
            })
            this.$api.submitQuotation({
                goods_info: JSON.stringify(arr),
                aid: this.aid,
                shipping_fee: this.new_shipping_fee,
            }).then(res => {
                this.$message.success('修改成功');
                this.getOrderDetail();
            }).catch(err => {
                this.$message.error(err);
            })
        },
        // 获取比价订单详情
        getOrderDetail() {
            this.$api.getPriceComparisonDetail({
                aid: this.aid,
            }).then(res => {
                this.detailData = res;
                this.new_shipping_fee = this.detailData.my_quotation.shipping_fee;
                let arr = this.detailData.my_quotation.goods_list;
                arr.forEach(item => {
                    item.real_price = 0;
                    item.quality_picture = '';
                })
                this.stowage_arr = arr;
            }).catch(err => {
                this.$message.error(err);
            });
        },
        // 获取折扣率列表
        getDiscountList() {
            this.$api.getDiscountList().then(res => {
                this.discountList = res;
            }).catch(err => {
                this.$message.error(err);
            });
        },
        // 更新报价
        updatePrice(row) {
            const ratio = parseFloat(row.ratio);
            const referPrice = parseFloat(row.refer_price);
            if (!isNaN(ratio) && !isNaN(referPrice)) {
                row.quotation_price = (referPrice * ratio).toFixed(2);
            }
        },
        // 更新折扣率
        updateDiscount(row) {
            const price = parseFloat(row.quotation_price);
            const referPrice = parseFloat(row.refer_price);
            if (!isNaN(price) && !isNaN(referPrice)) {
                row.ratio = (price / referPrice).toFixed(2);
            }
        },
    }
}
</script>

<style scoped>
.flex {
    display: flex;
}

.align-center {
    align-items: center;
}

.justify-center {
    justify-content: center;
}

.flex-wrap {
    flex-wrap: wrap;
}

.flex-direction-column {
    flex-direction: column;
}

.flex-sub {
    flex: 1;
}

.justify-around {
    justify-content: space-around;
}

.justify-between {
    justify-content: space-between;
}

.order-detail {
    padding: 20px;
    background-color: #fff;
}

/* 页面标题 */
.page-header {
    margin-bottom: 20px;
}

.page-box {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

/* 订单状态区域 */
.order-status-section {
    margin-bottom: 20px;
}

.order-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
}

.order-status {
    text-align: left;
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 15px;
}

.status-text {
    margin-bottom: 10px;
}

.status-label {
    font-size: 14px;
    color: #333;
    margin-right: 20px;
}

.order-sn {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

.payment-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: end;
}

.payment-status {
    font-weight: bold;
    font-size: 16px;
    color: #286CED;
}

.payment-tip {
    margin-top: 4px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
}

.payment-time {
    font-size: 14px;
    color: #666;
}

.time-value {
    color: #e74c3c;
    font-weight: 500;
}

.order-tip {
    font-size: 12px;
    color: #999;
    line-height: 1.5;
}

/* 信息区域 */
.info-section {
    display: flex;
    margin-bottom: 20px;
    gap: 10px;
    flex-wrap: wrap;
}

.info-left,
.info-right {
    width: calc(50% - 10px);
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    /* padding: 15px; */
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    background: #FAFAFA;
    color: #333;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    padding: 10px 15px;
}

.section-title::before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 16px;
    background-color: #286CED;
    margin-right: 8px;

}

.info-content {
    font-size: 14px;
    text-align: left;
    padding: 0px 15px 0px 15px;
}

.info-item {
    margin-bottom: 10px;
}

.info-label {
    color: #666;
    margin-right: 10px;
}

.info-value {
    color: #333;
}

.copy-btn {
    color: #286CED;
    cursor: pointer;
    margin-left: 10px;
}

/* 商品信息样式 */
.goods-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.goods-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #e8e8e8;
    margin-right: 15px;
}

.goods-details {
    min-height: 80px;
    flex: 1;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.goods-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
}

.goods-spec {
    font-size: 12px;
    color: #999;
}

.money_box {
    display: flex;
    flex-direction: column;
    align-items: end;
    margin-top: 20px;
}

.money-item {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    margin-bottom: 10px;
}

.payable-txt {
    font-weight: bold;
    font-size: 20px;
    color: #F02325;
    margin-left: 2px;
}

.dialog-content {
    width: 100%;
}

.form-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    label {
        font-weight: 400;
        font-size: 14px;
        color: #221E1F;
        margin-bottom: 16px;
    }
}

.dialog-footer {
    display: flex;
    justify-content: center;
}

::v-deep .el-statistic .con .number {
    font-size: 16px;
    color: #F02325;
    margin-left: 10px;
}

.shipping_fee {
    font-size: 14px;
    color: #F02325;
    text-align: left;
    margin-top: 10px;
}

.tips {
    font-weight: 400;
    font-size: 12px;
    color: #286CED;
}

.feeBox {
    display: flex;
    align-items: center;
    margin-top: 20px;
    justify-content: end;
    font-size: 14px;

    .el-input {
        width: 200px;
    }
}

.quote-btn {
    width: 140px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    background: #286CED;
    border-radius: 4px 4px 4px 4px;
}

.info-box {
    width: 100%;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
}

.userBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e8e8e8;
    padding: 15px;
    margin-bottom: 20px;
}

.buyer-info {
    display: flex;
    align-items: center;
    justify-content: center;
}

.buyer-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 10px;
}

.buyer-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin-bottom: 5px;
}

.sign-img {
    width: 100%;
    height: 100px;
}

.sign-text {
    font-size: 14px;
    color: #666;
    text-align: center;
    margin: 10px 0;
}

.load-img {
    width: 136px;
    height: 136px;
    border-radius: 8px;
    margin-right: 10px;
    margin-bottom: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .info-section {
        flex-direction: column;
    }

    .product-header,
    .product-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .product-info,
    .product-quantity,
    .product-buyer,
    .product-amount,
    .product-status,
    .product-operation {
        width: 100%;
        text-align: left;
        margin-bottom: 10px;
    }
}
</style>